var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"title text-center"},[_vm._v("Helpful Links")]),_c('helpful-link-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }